import { render, staticRenderFns } from "./FctInputControl.vue?vue&type=template&id=21fe4bd0&scoped=true"
import script from "./FctInputControl.vue?vue&type=script&lang=js"
export * from "./FctInputControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe4bd0",
  null
  
)

export default component.exports